import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { OptionMultiSelectComponent } from '@app/ui/option-multi-select/option-multi-select.component';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef
} from '@angular/material/legacy-dialog';
import { CdkDrag, CdkDropList } from '@angular/cdk/drag-drop';
import { NgFor, NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule } from '@angular/material/legacy-list';
import { IMultiSelectItem } from '@app/ui/option-multi-select/multi-select-item.interface';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@app/shared/shared.module';
import { Setting } from '@app/reports/report-settings/setting.model';

@Component({
  selector: 'acs-option-multi-select-dialog',
  templateUrl: './option-multi-select-dialog.component.html',
  styleUrls: ['../option-multi-select/option-multi-select.component.scss'],
  standalone: true,
  imports: [
    CdkDropList,
    NgFor,
    CdkDrag,
    MatIconModule,
    MatDialogModule,
    MatButtonModule,
    MatLegacyCheckboxModule,
    MatLegacyFormFieldModule,
    MatLegacyInputModule,
    MatLegacyListModule,
    OptionMultiSelectComponent,
    NgIf,
    FormsModule,
    SharedModule
  ]
})
export class OptionMultiSelectDialogComponent implements OnInit {
  @Output() itemMovedEvent = new EventEmitter();
  @Output() itemAddEvent = new EventEmitter<string>();

  public searchText = '';
  public jumpFocus: string;
  public available: IMultiSelectItem[] = [];
  public selected: IMultiSelectItem[] = [];
  public disableOk: boolean;
  public localSetting: Setting;
  public singleColumn: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { title: string; setting: Setting },
    private dialogRef: MatDialogRef<OptionMultiSelectDialogComponent>
  ) {}

  ngOnInit() {
    this.localSetting = new Setting(this.data.setting);
    this.updateLists();
    this.jumpFocus = 'searchText';
  }

  public onOkayClick(): void {
    this.updateLists();
    this.dialogRef.close(this.selected);
  }

  public updateLists(): void {
    this.available = this.localSetting.options.filter((x) => !x.selected);
    this.selected = this.localSetting.options.filter((x) => x.selected);
    this.disableOk =
      (this.selected.length === 0 && !this.data.setting.allowEmpty) ||
      (this.selected.length === 0 && this.data['minLimitSave']);
    this.singleColumn = this.data['singleColumn'];
  }

  public onNoClick(): void {
    this.dialogRef.close();
  }
}
